<template>
  <div class="app-mnp-in-data-input">
    <div class="form-wrapper">
      <form class="mnp-in-data-input" :id="'form' + _uid">
        <fieldset class="inputs-container">
          <div class="input-field">
            <label class="text-base-medium" for="firstName"> Anrede<span class="required" aria-hidden="true">*</span> </label>
            <div class="radio-group">
              <label>
                <input
                  type="radio"
                  name="gender"
                  value="FEMALE"
                  v-model="person_.gender"
                  required
                  @input="$v.person.gender.$touch"
                  aria-describedby="gender-hint"
                />
                <span class="custom-radio"></span>
                <span class="text-sm">Frau</span>
              </label>
              <label>
                <input
                  type="radio"
                  name="gender"
                  value="MALE"
                  v-model="person_.gender"
                  required
                  @input="$v.person.gender.$touch"
                  aria-describedby="gender-hint"
                />
                <span class="custom-radio"></span>
                <span class="text-sm">Herr</span>
              </label>
<!--              <label>--> <!-- Wurde vorerst ausgeblendet. Kann eingeblendet werden, sobald Magma die Option Divers hat  -->
<!--                <input-->
<!--                  type="radio"-->
<!--                  name="gender"-->
<!--                  value="DIVERSE"-->
<!--                  v-model="person_.gender"-->
<!--                  required-->
<!--                  @input="$v.person.gender.$touch"-->
<!--                  aria-describedby="gender-hint"-->
<!--                />-->
<!--                <span class="custom-radio"></span>-->
<!--                <span class="text-sm">Divers</span>-->
<!--              </label>-->
            </div>
            <small id="gender-hint" class="sr-only">Pflichtfeld</small>
            <div id="gender-error" class="error-feedback text-sm" v-if="!isValid('gender', 'person') && $v.person.gender.$dirty">
              <span v-if="$v.person.gender.required === false"> Dieses Feld ist ein Pflichtfeld<br /> </span>
            </div>
          </div>
        </fieldset>
        <fieldset label="Name" label-class="visually-hidden" class="inputs-container">
          <div class="input-field">
            <label class="text-base-medium" for="firstName"> Vorname<span class="required" aria-hidden="true">*</span> </label>
            <ValidationIndicator :dirty="$v.person.firstName.$dirty" :valid="isValid('firstName', 'person')">
              <input
                id="firstName"
                name="firstName"
                placeholder="Vorname"
                type="text"
                class="input"
                v-model="person_.firstName"
                pattern="[a-zA-Z]*"
                required
                @blur="$v.person.firstName.$touch"
                @click="$v.person.firstName.$reset"
                :class="{
                  'input--invalid': $v.person.firstName.$dirty && !isValid('firstName', 'person'),
                  'input--valid': $v.person.firstName.$dirty && isValid('firstName', 'person')
                }"
                aria-describedby="firstname-hint"
                aria-errormessage="firstname-error"
              />
            </ValidationIndicator>
            <small id="firstname-hint" class="sr-only">Pflichtfeld</small>
            <div
              id="firstname-error"
              class="error-feedback text-sm"
              v-if="!isValid('firstName', 'person') && $v.person.firstName.$dirty"
            >
              <span v-if="$v.person.firstName.required === false"> Bitte gib deinen Vornamen ein.<br /> </span>
              <span v-if="$v.person.firstName.alphaSpaces === false">
                Der Vorname darf nur Buchstaben und Leerzeichen enthalten.<br />
              </span>
            </div>
          </div>

          <div class="input-field">
            <label class="text-base-medium" for="lastName"> Nachname<span class="required" aria-hidden="true">*</span> </label>
            <ValidationIndicator :dirty="$v.person.lastName.$dirty" :valid="isValid('lastName', 'person')">
              <input
                id="lastName"
                name="lastName"
                placeholder="Nachname"
                type="text"
                class="input"
                v-model="person_.lastName"
                required
                @blur="$v.person.lastName.$touch"
                @click="$v.person.lastName.$reset"
                :class="{
                  'input--invalid': $v.person.lastName.$dirty && !isValid('lastName', 'person'),
                  'input--valid': $v.person.lastName.$dirty && isValid('lastName', 'person')
                }"
                aria-describedby="lastname-hint"
                aria-errormessage="lastname-error"
              />
            </ValidationIndicator>
            <small id="lastname-hint" class="sr-only">Pflichtfeld</small>
            <div id="lastname-error" class="error-feedback text-sm" v-if="!isValid('lastName', 'person') && $v.person.lastName.$dirty">
              <span v-if="$v.person.lastName.required === false"> Bitte gib deinen Nachnamen ein.<br /> </span>
              <span v-if="$v.person.lastName.alphaSpaces === false">
                Der Nachname darf nur Buchstaben und Leerzeichen enthalten.<br />
              </span>
            </div>
          </div>
        </fieldset>
        <fieldset label="Geburtstag" label-class="visually-hidden" class="inputs-container">
          <div class="inputs-container">
            <h2 class="visually-hidden">Persönliche Informationen</h2>

            <div class="input-field">
              <label class="text-base-medium" for="birthdate">
                Geburtsdatum<span class="required" aria-hidden="true">*</span>
              </label>
              <ValidationIndicator :dirty="$v.person.birthDate.$dirty" :valid="isValid('birthDate', 'person')">
                <input
                  id="birthdate"
                  type="text"
                  name="birthDate"
                  placeholder="TT.MM.JJJJ  (z.B. 10.12.1988)"
                  class="input"
                  v-model="person_.birthDate"
                  required
                  @blur="$v.person.birthDate.$touch"
                  @click="$v.person.birthDate.$reset"
                  :class="{
                    'input--invalid': $v.person.birthDate.$dirty && !isValid('birthDate', 'person'),
                    'input--valid': $v.person.birthDate.$dirty && isValid('birthDate', 'person')
                  }"
                  autocomplete="off"
                  aria-errormessage="birthdate-error"
                  aria-describedby="birthdate-hint"
                />
              </ValidationIndicator>

              <small id="birthdate-hint" class="sr-only">Pflichtfeld</small>
              <div
                id="birthdate-error"
                class="error-feedback text-sm"
                v-if="!isValid('birthDate', 'person') && $v.person.birthDate.$dirty"
              >
                <span v-if="$v.person.birthDate.required === false">
                  Bitte gib dein Geburtsdatum ein.
                </span>
                <span v-if="$v.person.birthDate.validDateFormat === false">
                  Ungültiges Format. Bitte gib dein Geburtsdatum im Format TT.MM.JJJJ ein (z. B. 15.08.2005).
                </span>
              </div>
            </div>
          </div>
        </fieldset>

        <div class="inputs-container">
          <div class="input-field">
            <label class="text-base-medium" for="msisdn">
              Zu portierende Rufnummer<span class="required" aria-hidden="true">*</span>
            </label>
            <ValidationIndicator :dirty="$v.portationMsisdn.$dirty" :valid="isValid('portationMsisdn')">
              <input
                id="msisdn"
                name="portationMsisdn"
                type="text"
                class="input"
                v-model.trim="portationMsisdn_"
                required
                @blur="$v.portationMsisdn.$touch"
                @click="$v.portationMsisdn.$reset"
                :class="{
                  'input--invalid': $v.portationMsisdn.$dirty && !isValid('portationMsisdn'),
                  'input--valid': $v.portationMsisdn.$dirty && isValid('portationMsisdn')
                }"
                aria-describedby="portationMsisdn-hint"
                aria-errormessage="portationMsisdn-error"
              />
            </ValidationIndicator>
            <small id="portationMsisdn-hint" class="sr-only">Pflichtfeld</small>
            <div
              id="portationMsisdn-error"
              class="error-feedback text-sm"
              v-if="!isValid('portationMsisdn') && $v.portationMsisdn.$dirty"
            >
              <span v-if="$v.portationMsisdn.required === false"> Bitte gib deine LIDL Connect Rufnummer ein.<br /> </span>
            </div>
          </div>
        </div>
        <ProviderList :invalid.sync="dataInvalid" :selected-keys.sync="selectedKeys_"> </ProviderList>
      </form>
    </div>
  </div>
</template>

<script>
import { helpers, required, sameAs } from 'vuelidate/lib/validators'
import ProviderList from './ProviderList.vue'
import { validDate, validDateFormat } from '@/validators/date'
import isValid from '@/mixins/isValid'
import { validationMixin } from 'vuelidate'
import syncProperty from '@/mixins/syncProperty'
import ValidationIndicator from '@/components-v2/generic/ValidationIndicator.vue'

const isPhoneNumber = helpers.regex('phoneNumber', /^[+]?[0-9]*$/)
export default {
  name: 'DataInput',
  data() {
    return {
      dataInvalid: true
    }
  },
  props: {},
  components: {
    ProviderList,
    ValidationIndicator
  },
  computed: {
    calendarSettings() {
      return this.$config.calendar.calendarSettings
    }
  },
  methods: {
    selectDate(ctx) {
      if (ctx.selectedDate) {
        this.person.birthDate = ctx.selectedFormatted
      }
    }
  },
  mixins: [
    validationMixin,
    isValid,
    syncProperty('selectedKeys', 'selectedKeys_'),
    syncProperty('person', 'person_'),
    syncProperty('portationMsisdn', 'portationMsisdn_')
  ],
  watch: {
    '$v.$invalid': function(newValue) {
      this.$emit('update:invalid', newValue)
    }
  },
  mounted() {
    this.$emit('update:invalid', this.$v.$invalid)
  },
  validations() {
    return {
      portationMsisdn: { required, isPhoneNumber },
      person: {
        gender: { required },
        firstName: { required },
        lastName: { required },
        birthDate: { required, validDate, validDateFormat }
      },
      dataInvalid: {
        sameAs: sameAs(() => false)
      }
    }
  }
}
</script>
